import React from "react";
import TextColumn from "@/library/components/texts/TextColumn";
import { cn } from "@/storyblok/utils/cn";
import Image from "next/image";

export default function TextColumnSection({
  backgroundColor,
  backgroundImage = false,
  columns,
}) {
  const sectionBackgroundClasses = cn("py-16", {
    "bg-bg-color-white": backgroundColor === "bg-white",
    "bg-bg-color-light": backgroundColor === "bg-light",
    "bg-bg-color-dark": backgroundColor === "bg-dark",
    "bg-bg-color-grey": backgroundColor === "bg-grey",
    "bg-bg-color-orange": backgroundColor === "bg-orange",
  });

  const backgroundImageClasses = cn({
    "-skew-y-3  bg-cover bg-center": backgroundImage,
  });

  return (
    <section className={`${sectionBackgroundClasses} relative`}>
      <div
        className={`md:py-24 px-8 py-16 bg-bg-color-grey ${backgroundImageClasses} -skew-y-3 overflow-hidden relative`}
      >
        {backgroundImage && (
          <div
            className="absolute inset-0 flex justify-center items-center -z-10 h-full top-[25%]"
            aria-hidden="true"
          >
            <Image
              src="/images/NidhoggLogga.png"
              alt="Nidhogg Logga"
              width={800}
              height={500}
              priority
              className="min-w-[250%] min-h-[150%] md:min-w-[175%] md:min-h-[175%] max-w-[200%] max-h-[200%] -rotate-45 aspect-square object-contain !important"
            />
          </div>
        )}
        <div className="skew-y-3 flex flex-wrap md:justify-center gap-12 md:gap-24">
          {columns.map((column) => (
            <div key={column._uid}>
              <TextColumn
                title={column.title}
                text={column.text}
                buttons={column.buttons || []}
                textColor={column.textColor}
                titleColor={column.titleColor}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
